<nav class="navbar sticky-top navbar-light bg-ligth">
  <div class="container-xl">
    <div class="row" style="width: 100vw !important">
      <!-- mobile -->
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <a style="text-decoration: none" href="https://portaldolojista.blukit.com.br/auth" target="_blank" aria-label="Acessar Portal do Lojista">
            <div class="d-flex align-items-center m-2">
              <div class="d-xl-none">
                <i class="bi bi-shop" style="font-size: 24px; color: var(--main-blue)" aria-hidden="true"></i>
              </div>
              <div
                style="line-height: 1; text-align: start; font-size: 11px; color: var(--main-blue); cursor: pointer;"
                class="d-xl-none p-1">
                <span>PORTAL<br />DO LOJISTA</span>
              </div>
            </div>
          </a>
        </div>
        <div>
          <button type="button" (click)="openModalSearch()" class="d-xl-none bi bi-search fa-fw fa-2x fw-bold p-1"
            style="font-size: 26px; color: var(--main-blue); font-weight: 900; cursor: pointer; background: transparent; border: 0;"
            aria-label="Abrir busca"></button>
          <button type="button" (click)="openModalMenu()" class="d-xl-none bi bi-list fa-fw fa-2x fw-bold p-1"
            style="font-size: 26px; color: var(--main-blue); font-weight: 900; cursor: pointer; background: transparent; border: 0;"
            aria-label="Abrir menu"></button>
        </div>
      </div>
      <div class="d-xl-none container-area-mobile">
        <a href="" class="nav-brand">
          <img style="margin-bottom: -5em" src="/assets/logos/logo-yellow.svg" alt="Blukit" width="81px" height="57px" />
        </a>
      </div>
      <!-- fim mobile -->

      <div class="d-none d-xl-flex col-md-auto col-lg-1">
        <a href="" class="nav-brand">
          <img src="/assets/logos/logo-yellow.svg" alt="Blukit" width="95px" height="95px" />
        </a>
      </div>

      <div class="d-none col-xl-8 d-xl-flex align-items-end justify-content-end">
        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="" data-top-nav-item (keydown)="onTopNavKeydown($event)">Home</a>
          </li>

          <li class="nav-item d-flex align-items-start dropdown" aria-haspopup="true" [attr.aria-expanded]="activeMenu === 'products' ? 'true' : 'false'" (mouseenter)="setActiveMenu('products')" (mouseleave)="clearActiveMenu('products', $event)" (focusin)="setActiveMenu('products')" (focusout)="clearActiveMenu('products', $event)" (keydown.escape)="hideCategory(); activeMenu = null">
            <a class="nav-link" href="/linhas" data-top-nav-item data-menu-trigger="products" (keydown)="onTopNavKeydown($event)">Produtos</a>
            <a class="nav-link" aria-hidden="true" tabindex="-1">
              <img src="/assets/icons/icon-arrow.svg" alt="" aria-hidden="true" style="width: 10px; height: 7px;" />
            </a>

            <div class="dropdown-menu">
              <div class="d-flex">
                <div class="d-flex flex-column nav-link dropdown">
                  <div *ngFor="let category of categories" style="min-width: 200px; width: 100%;">
                    <a class="dropdown-item dropleft d-flex justify-content-between align-items-center"
                      routerLink="linhas/{{ category.slug }}" (mouseover)="showSubcategory(true, category)" (focus)="showSubcategory(true, category)" [attr.aria-expanded]="activeCategoryId === category.id ? 'true' : 'false'" [attr.data-products-category]="category.id" (keydown)="onProductsCategoryKeydown($event, category)">
                      {{ category.nome }}
                      <span *ngIf="category && !category.ambiente"
                        style="color: #848fa3; font-size: 14px; text-align: end">
                        <i class="bi bi-chevron-right m-2 pt-2"></i>
                      </span>
                    </a>
                  </div>
                </div>

                <div *ngIf="subCategories && subCategories.length" style="border: 1px solid #ccc; margin: 0 15px"></div>
                <div *ngIf="subCategories && subCategories.length" class="d-flex flex-column dropdown-subitem"
                  style="min-width: 200px">
                  <a class="dropdown-item dropleft d-flex justify-content-between align-items-center"
                    *ngFor="let subCategorie of subCategories" (mouseover)="showSubSubcategory(true, subCategorie)" (focus)="showSubSubcategory(true, subCategorie)"
                    href="{{subCategorie.link}}" (click)="hideCategory()" [attr.aria-expanded]="activeSubcategoryId === subCategorie.id ? 'true' : 'false'" [attr.data-products-subcategory]="subCategorie.id" [attr.data-parent-category-id]="subCategorie.parent_id" (keydown)="onProductsSubcategoryKeydown($event, subCategorie)">
                    {{ subCategorie.nome }}
                    <span style="color: #848fa3; font-size: 14px; text-align: end">
                      <i class="bi bi-chevron-right m-2 pt-2"></i>
                    </span>
                  </a>
                </div>

                <div *ngIf="subSubCategorie && subSubCategorie.length"
                  style="border: 1px solid #ccc; margin: 0 15px"></div>
                <div *ngIf="subSubCategorie && subSubCategorie.length" class="d-flex flex-column dropdown-subitem"
                  style="width: 200px">
                  <div *ngFor="let subCategorieItem of subSubCategorie">
                    <a *ngIf="subCategorieItem.hasProducts" href="{{subCategorieItem.link}}" [attr.data-products-subsubcategory]="subCategorieItem.id" [attr.data-parent-subcategory-id]="subCategorieItem.parent_id" (keydown)="onProductsSubSubcategoryKeydown($event, subCategorieItem)">
                      {{ subCategorieItem.nome }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item d-flex" (mouseover)="hideCategory()" (focusin)="hideCategory()">
            <a class="nav-link dropdown" routerLink="/onde-encontrar" data-top-nav-item (keydown)="onTopNavKeydown($event)">Onde encontrar</a>
          </li>

          <li class="nav-item d-flex dropdown" aria-haspopup="true" [attr.aria-expanded]="activeMenu === 'atendimento' ? 'true' : 'false'" (mouseenter)="setActiveMenu('atendimento')" (mouseleave)="clearActiveMenu('atendimento', $event)" (focusin)="setActiveMenu('atendimento')" (focusout)="clearActiveMenu('atendimento', $event)" (keydown.escape)="hideCategory(); activeMenu = null">
            <a class="nav-link dropdown" href="/atendimento" data-top-nav-item data-menu-trigger="atendimento" (keydown)="onTopNavKeydown($event)">Atendimento</a>
            <a class="nav-link" aria-hidden="true" tabindex="-1">
              <img style="width: 10px; height: 7px;" src="../../../../assets/icons/icon-arrow.svg" alt="" aria-hidden="true" />
            </a>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="atendimento/assistencia-tecnica" data-atendimento-item (keydown)="onTopNavKeydown($event)">Assistência Técnica</a>
              <a class="dropdown-item" href="atendimento/duvidas-frequentes" data-atendimento-item (keydown)="onTopNavKeydown($event)">Dúvidas Frequentes</a>
              <a class="dropdown-item" href="atendimento/fale-conosco" data-atendimento-item (keydown)="onTopNavKeydown($event)">Fale Conosco</a>
              <a class="dropdown-item" href="atendimento/financeiro" data-atendimento-item (keydown)="onTopNavKeydown($event)">Financeiro</a>
              <a class="dropdown-item" href="atendimento/ouvidoria" data-atendimento-item (keydown)="onTopNavKeydown($event)">Ouvidoria</a>
              <a class="dropdown-item"
                href="https://faleseguro.com.br/welcome?uuid=3941ff81-1ade-4673-ad17-0994d7bf5a41" target="_blank" data-atendimento-item (keydown)="onTopNavKeydown($event)">Canal
                de Ética</a>
            </div>
          </li>

          <li class="nav-item d-flex dropdown" aria-haspopup="true" [attr.aria-expanded]="activeMenu === 'sobre' ? 'true' : 'false'" (mouseenter)="setActiveMenu('sobre')" (mouseleave)="clearActiveMenu('sobre', $event)" (focusin)="setActiveMenu('sobre')" (focusout)="clearActiveMenu('sobre', $event)" (keydown.escape)="hideCategory(); activeMenu = null">
            <a class="nav-link dropdown" href="sobre" data-top-nav-item data-menu-trigger="sobre" (keydown)="onTopNavKeydown($event)">Sobre a Blukit</a>
            <a class="nav-link" aria-hidden="true" tabindex="-1">
              <img style="width: 10px; height: 7px;" src="../../../../assets/icons/icon-arrow.svg" alt="" aria-hidden="true" />
            </a>
            <div class="dropdown-menu">
              <div class="d-flex">
                <div class="d-flex flex-column nav-link dropdown">
                  <a class="dropdown-item" href="sobre/sobre-download" (mouseover)="showReports(false)" (focus)="showReports(false)" data-about-item (keydown)="onAboutItemKeydown($event, 'download')">Download</a>
                  <a class="dropdown-item dropleft" (mouseover)="showReports(false)" (focus)="showReports(false)" href="sobre" data-about-item (keydown)="onAboutItemKeydown($event, 'about')">Sobre a Blukit</a>
                  <a class="dropdown-item dropleft" (mouseover)="showReports(true)" (focus)="showReports(true)" [attr.aria-expanded]="reportsOpen ? 'true' : 'false'" data-about-item data-menu-trigger="sobre" (keydown)="onAboutItemKeydown($event, 'reports')">
                    Relatório de Transparência
                    <span style="color: #848fa3; font-size: 12px; text-align: end">
                      <i class="bi bi-chevron-right"></i>
                    </span>
                  </a>
                </div>

                <div *ngIf="subcategorieReports.length" style="border: 1px solid #ccc; margin: 0 15px"></div>
                <div>
                  <div *ngIf="subcategorieReports && subcategorieReports.length"
                    class="d-flex flex-column dropdown-subitem" style="width: 200px">
                    <a class="dropdown-item dropleft d-flex justify-content-between align-items-center"
                      *ngFor="let subCategorie of subcategorieReports" href="{{subCategorie.link}}" target="_blank"
                      (click)="hideReport()" data-about-report-item (keydown)="onAboutReportKeydown($event)">
                      {{ subCategorie.nome }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown" (mouseover)="hideCategory()" style="padding: 0; white-space: nowrap; margin-left: 10px;">
            <a class="nav-link dropdown" target="_blank" href="https://blukit.portaldetalentos.senior.com.br/" data-top-nav-item (keydown)="onTopNavKeydown($event)">
              Trabalhe Conosco
            </a>
          </li>
        </ul>
      </div>

      <div class="d-flex align-items-center justify-content-center col-md-auto col-lg-3 header-nav">
        <div class="m-2 d-none d-xl-flex" style="height: 40px; border: 1px solid #848fa35e !important"></div>

        <a style="text-decoration: none" href="https://portaldolojista.blukit.com.br/auth" target="_blank">
          <div class="d-flex align-items-center m-2" style="padding-right: 7px">
        <div class="d-none d-xl-flex p-2 pt-0 pb-0">
              <i class="bi bi-shop" style="font-size: 26px; color: var(--main-blue)" aria-hidden="true"></i>
            </div>
            <div
              style="line-height: 1; text-align: start; font-size: 11px; color: var(--main-blue); cursor: pointer;"
              class="d-none d-xl-flex p-1">
              <span>PORTAL<br />DO LOJISTA</span>
            </div>
          </div>
        </a>

        <div class="d-none d-xl-block dropdown blukit-pra-voce-menu">
          <button
            type="button"
            class="blukit-pra-voce-trigger"
            aria-label="Abrir menu Blukit para Você"
            aria-haspopup="true"
          >
            <img
              class="blukit-pra-voce-icon"
              src="/assets/icons/icone_Blukit_para_voce.svg"
              alt=""
              aria-hidden="true"
            />
            <img
              class="blukit-pra-voce-arrow"
              src="/assets/icons/icon-arrow.svg"
              alt=""
              aria-hidden="true"
            />
          </button>

          <div class="dropdown-menu">
            <a class="dropdown-item" href="/blog">Blog</a>
            <a class="dropdown-item" routerLink="/videos">Vídeos</a>
            <a class="dropdown-item" target="_blank" rel="noopener noreferrer" href="https://ead.blukit.com.br/">EAD</a>
            <!-- <button type="button" class="dropdown-item" disabled>Informações Técnicas</button> 
            <button type="button" class="dropdown-item" disabled>Top Soluções</button> -->
          </div>
        </div>

        <button type="button" class="d-none d-xl-flex bi bi-search fa-fw fa-2x fw-bold p-1 navbar-search-button"
          style="font-size: 22px; color: var(--main-blue); font-weight: 900; cursor: pointer; background: transparent; border: 0;"
          (click)="openModalSearch()" aria-label="Abrir busca"></button>
      </div>
    </div>
  </div>
</nav>
